import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../../utils/errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const executeTableRowRequest = async ({
  contentId,
  actionId,
  actionRowIds,
}: {
  contentId: string;
  actionId: string;
  actionRowIds: string[];
}) => {
  const response = await portalGatewayClient.table.executeRowRequest(
    contentId,
    {
      actionId,
      actionRowIds,
    }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error executing row request'),
      response.status
    );
  }
};
